import { environment } from "../../environments/Environment";
import { httpService } from "../common/HttpService";

import { v4 as uuidv4 } from "uuid";
import queryString from "query-string";

export class UserSession {
  // query params from iframe

  gameCode = "vleague";
  playerId = "";
  playerName = "";
  token = "";
  languageCode = "";
  currencyCode = "";
  platformId = "";
  operatorId = "";
  brand = "";
  region = "";
  isReal = "";
  gameType = "";

  // gameCode=vleague

  // &playerId=126894
  // &playerName=undefined
  // &token=undefined

  // &languageCode=en
  // &currencyCode=INR

  // &platformId=0
  // &operatorId=demo
  // &brand=demo

  // &isReal=true
  // &gameType=CASH/FREE

  constructor(queryParams) {
    if (!queryParams) {
      queryParams = {};
    }
    Object.assign(this, queryParams);

    if (
      !queryParams.gameCode ||
      queryParams.gameCode === "undefined" ||
      queryParams.gameCode === "null"
    ) {
      this.gameCode = "";
    }
    if (
      !queryParams.playerId ||
      queryParams.playerId === "undefined" ||
      queryParams.playerId === "null"
    ) {
      this.playerId = "";
    }
    if (
      !queryParams.playerName ||
      queryParams.playerName === "undefined" ||
      queryParams.playerName === "null"
    ) {
      this.playerName = "";
    }
    if (
      !queryParams.token ||
      queryParams.token === "undefined" ||
      queryParams.token === "null"
    ) {
      this.token = "";
    }
    if (
      !queryParams.languageCode ||
      queryParams.languageCode === "undefined" ||
      queryParams.languageCode === "null"
    ) {
      this.languageCode = "";
    }

    if (
      !queryParams.currencyCode ||
      queryParams.currencyCode === "undefined" ||
      queryParams.currencyCode === "null"
    ) {
      this.currencyCode = "";
    }
    if (
      !queryParams.platformId ||
      queryParams.platformId === "undefined" ||
      queryParams.platformId === "null"
    ) {
      this.platformId = "";
    }

    if (
      !queryParams.operatorId ||
      queryParams.operatorId === "undefined" ||
      queryParams.operatorId === "null"
    ) {
      this.operatorId = "";
    }

    if (
      !queryParams.brand ||
      queryParams.brand === "undefined" ||
      queryParams.brand === "null"
    ) {
      this.brand = "";
    }

    if (
      queryParams.region ||
      queryParams.region === "undefined" ||
      queryParams.region === "null"
    ) {
      this.region = "";
    }
    if (
      queryParams.isReal ||
      queryParams.isReal === "undefined" ||
      queryParams.isReal === "null"
    ) {
      this.isReal = "";
    }
    if (
      queryParams.gameType ||
      queryParams.gameType === "undefined" ||
      queryParams.gameType === "null"
    ) {
      this.gameType = "";
    }
  }
}

class SessionService {
  token = "";
  playerId = "_99";
  extraData = {
    gameId: "vleague",
    platformId: "0",
    operatorId: "demo",
    brand: "demo",
    currency: "INR",
    region: "IN",
    language: "EN",
    playerName: ""
  };
  userSession = new UserSession();

  initSession() {
    const rgsInitParams = {
      token: this.userSession.token,
      playerId: this.userSession.playerId,
      extraData: {
        currency: this.userSession.currencyCode,
        platformId: this.userSession.platformId,
        operatorId: this.userSession.operatorId,
        brand: this.userSession.brand,
        region: this.userSession.region,
        language: this.userSession.languageCode,
        gameId: this.userSession.gameCode,
        playerName: this.userSession.playerName
      },
    };
    console.log("rgsinitParams", rgsInitParams);
    return httpService.post("rgs/init", rgsInitParams);
  }

  getRGSSession(playerId) {
    const rgsSession = {
      token: this.userSession.token,
      // transactionId: "",
      // amount: 0,
      // roundId: "",
      playerId: playerId,
      currency: this.userSession.currencyCode,
      extraData: {
        gameId: this.userSession.gameCode,
        platformId: this.userSession.platformId,
        operatorId: this.userSession.operatorId,
        brand: this.userSession.brand,
        currency: this.userSession.currencyCode,
        region: this.userSession.region,
        language: this.userSession.languageCode,
        playerName: this.userSession.playerName
      },
    };
    return rgsSession;
  }

  setUserSession(_userSession) {
    let abc = queryString.parse(_userSession);
    let userSession = new UserSession({ ...abc });
    this.userSession = userSession;

    if (!this.userSession.token && abc.operatorId == "demo") {
      this.userSession.token = uuidv4();
    }

    if (!this.userSession.region) {
      this.userSession.region = environment.defaultSessionParams.region;
    }

    if (!this.userSession.languageCode) {
      this.userSession.languageCode = environment.defaultSessionParams.language;
    }

    if (!this.userSession.currencyCode) {
      this.userSession.currencyCode = environment.defaultSessionParams.currency;
    }

    if (!this.userSession.playerName) {
      this.userSession.playerName = environment.defaultSessionParams.playerName;
    }
    // localStorage.setItem("vl_user_session", JSON.stringify(this.userSession));
  }

  getUserSession() {
    // let userSession = JSON.parse(
    //   localStorage.getItem("vl_user_session") || "{}"
    // );
    return this.userSession;
  }

  updateSession(initData) {
   if(initData?.currencyCode){
    this.userSession.currencyCode = initData.currencyCode;
   }
  }
}

export const sessionService = new SessionService();
